import type { Maybe, ValueEvent } from '@adornis/base/utilTypes.js';
import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/digitale-helden-shared/client/theme/d-icon.js';
import '@adornis/digitale-helden-shared/client/theme/d-input.js';
import { FormField } from '@adornis/formfield/form-field.js';
import { html } from 'lit-html';
import { customElement, state } from 'lit/decorators.js';
import { fromEvent } from 'rxjs';

@customElement('las-search-input')
export class LASSearchInput extends FormField<Maybe<string>> {
  @state() private _value = this.value.value;

  override connectedCallback(): void {
    super.connectedCallback();

    fromEvent(this, 'keyup').subscribe(e => {
      if (!('key' in e) || e.key !== 'Enter') return;
      this._setValue();
    });
  }

  override render() {
    return html`
      <d-flex ${css({ position: 'relative' })}>
        <d-input
          placeholder="Suche"
          .value=${this.value.value}
          @value-changed=${(e: ValueEvent<string>) => {
            this._value = e.detail.value;
          }}
        >
        </d-input>
        <d-icon
          @click=${() => {
            this._setValue();
          }}
          solid
          ${css({
            position: 'absolute',
            right: '14.5px',
            bottom: '14.5px',
            color: this.value.value === this._value ? 'transparent' : this.colors.accent,
            cursor: 'pointer',
          })}
        >
          magnifying-glass
        </d-icon>
      </d-flex>
    `;
  }

  private _setValue() {
    this.value.next(this._value);
    this.dispatchEvent(new CustomEvent('value-picked', { detail: { value: this._value } }));
  }
}
